<template>
  <div>
	  <Header :sel='4' @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <!--banner-->
	    <div class="banner"> </div>
      <!--banner--> 
      
      <!--neirong-->
      <div class="bread_bg">
    <div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)">公司新闻</a></div>
  </div>
      <div class="neirong">
    <div class="fenlei_bg">
          <div class="fenlei_l"><b>快速检索新闻</b> <a href="javascript:void(0)" @click="selData(item.id)" v-for="(item,index) in tabList" :key="index" :class="{'selected0':type==item.id}">{{item.name}}</a></div>
          <div class="fenlei_r">
        <input name="" type="text"  placeholder="搜索新闻资讯" class="search_txt2"/>
        <input name="" type="button"  class="search_but2"/>
      </div>
        </div>
   <ul class="news_list">
        <li v-for="item in list">
          <div class="news_l"><a href="javascript:void(0)" @click="goDetail(item.id)"><img :src="item.image" /></a></div>
          <div class="news_m">
            <div class="news_r_t"><a href="javascript:void(0)" @click="goDetail(item.id)">{{item.title}}</a></div>
            <div class="news_r_c">{{item.description}}</div></div>
          <div class="news_r">
           <p><strong>{{item.publishDate|formatMonthDay}}</strong> </p>
           <p>{{item.publishDate| formatYear}}</p>
          </div>
          <div class="clear"></div>
        </li>
               
      </ul>
	        <ul id="page">
	            <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
	            <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
	            <li class="total">共{{totalPage}}页</li>
	        </ul>
	      </div>
	    </div>
	         <Footer></Footer> 
	   
	  </div>
	  
    
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getNewList} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			list:[],
			pageNum: 1,
			indexs: [],
			totalPage: 0,
			showPhone:false,
			type:'2201',
			tabList:[{
				name:'公司新闻',
				id:'2201'
			},{
				name:'行业新闻',
				id:'2202'
			}]
		}
  	},

  	mounted() {
	  this.getData()
  	},
	filters: {
    formatYear(date) {
      // 假设日期格式为 YYYY-MM-DD
      return date.split('-')[0];
    },
    formatMonthDay(date) {
      // 假设日期格式为 YYYY-MM-DD
      const parts = date.split('-');
      return `${parts[1]}-${parts[2]}`;
    }
  },

  	methods: {
		changePhone(val){
			this.showPhone=val
		},
		goNext(url){
			this.$router.push({
				path:url,
			})
		},
		selData(id,name){
			this.selName=name
			this.type=id;
			this.getData()
		},
		checkIndex() {
		    var left = 1;
		    var right = this.totalPage;
		    var ar = [];
		    if (this.totalPage >= 3) {
		        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
		            left = this.pageNum - 1
		            right = this.pageNum + 1
		        } else {
		            if (this.pageNum <= 1) {
		                left = 1
		                right = 3
		            } else {
		                right = this.totalPage
		                left = this.totalPage - 2
		            }
		        }
		    }
		    while (left <= right) {
		        ar.push(left)
		        left++
		    }
		    this.indexs = ar
		
		},
		goPage(type) {
		    if (type == 'home') {
		        this.pageNum = 1
		    } else if (type == 'end') {
		        this.pageNum = Number(this.totalPage)
		
		    } else if (type == 'last') {
		        if (this.pageNum > 1) {
		            this.pageNum = this.pageNum - 1
		        }
		    } else if (type == 'next') {
		        if (this.pageNum < (this.totalPage)) {
		            this.pageNum = this.pageNum + 1
		        }
		    } else {
		        this.pageNum = type
		    }
		    this.getData()
		},
		init(){
			//this.params.pageNumber=1;
			this.getData()
		},
		getData(){
			let par={
				categoryCode: this.type,
				pageNumber: this.pageNum,
				pageSize: 5,
				
			}
			getNewList(par).then(res => {
			  this.list = res.data.list;
			  this.totalPage = Math.ceil(res.data.totalRow / 5)
			  this.checkIndex();
			});
		},
		goDetail(id){
			this.$router.push({
				path:'/context',
				query:{id:id}
			})
		}
     
  	}
  }
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_04.png');
	}


</style>
